<template>

	<div>

		<!-- ACTIVATE SCREEN -->
	    <div class="activate-voucher" >
	      <h2 :style="getStyle('h2')" v-html="config.sub_header_text"></h2>
        <small v-if="config.contact_vouchers_amount && config.contact_vouchers_amount > 1">You have {{config.contact_vouchers_amount}} uses of this voucher.</small>
	    </div>

	    <div class="activate-steps">


	      <div class="step" v-for="(step, index) in config.how_to_use_steps">
          <div class="numberCircle" :style="getStyle('number-circle')">{{index+1}}</div>
          <p :style="getStyle('p')">{{step}}</p>
        </div>
	    </div>

	    <div class="button-wrapper">

        <button v-on:click="$store.commit('SET_SCREEN','activation')" :style="getStyle('button')">
         {{config.go_to_activate_button_text}}
        </button>

      </div>

	</div>

</template>

<script>
export default {
  name: 'ActivateVoucher',
  props: {
    email: String
  },
  computed: {
      config(){
          return this.$store.getters.getCamapignConfig;
      },

      loaded(){
          return this.$store.getters.getAppLoaded;
      },

      apiCampaignParams(){
          return this.$store.getters.getCampaignApiVars;
      },

      screen(){
          return this.$store.getters.getScreen;
      }
  }
}
</script>
<style lang="scss">

    .activate-steps {
      margin-top: 30px;
    }

    small {
      font-weight: bold;
    }

</style>
